import React from "react";

function FilterButton({ text, onClick, selected, isMobile }) {
    return (
        <button
            type="button"
            className={`filter-button ${isMobile ? "body-small" : "body-medium"} ${selected ? "selected" : ""}`}
            onClick={onClick}
            aria-pressed={selected}
        >
            {text}
        </button>
    )
}

export default FilterButton;
